import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Game } from "./components/Game";
import React, { useEffect, useState } from "react";
import { Infos } from "./components/panels/Infos";
import { useTranslation } from "react-i18next";
import { InfosFr } from "./components/panels/InfosFr";
import { Settings } from "./components/panels/Settings";
import { useSettings } from "./hooks/useSettings";
import { Stats } from "./components/panels/Stats";
import { Worldle } from "./components/Worldle";

function App() {
  const { i18n } = useTranslation();

  const [infoOpen, setInfoOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [statsOpen, setStatsOpen] = useState(false);

  const [settingsData, updateSettings] = useSettings();

  useEffect(() => {
    if (settingsData.theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [settingsData.theme]);

  return (
    <>
      <ToastContainer
        hideProgressBar
        position="top-center"
        transition={Flip}
        theme={settingsData.theme}
        autoClose={2000}
        bodyClassName="font-bold text-center"
      />
      {i18n.resolvedLanguage === "no" ? (
        <InfosFr
          isOpen={infoOpen}
          close={() => setInfoOpen(false)}
          settingsData={settingsData}
        />
      ) : (
        <Infos
          isOpen={infoOpen}
          close={() => setInfoOpen(false)}
          settingsData={settingsData}
        />
      )}
      <Settings
        isOpen={settingsOpen}
        close={() => setSettingsOpen(false)}
        settingsData={settingsData}
        updateSettings={updateSettings}
      />
      <Stats
        isOpen={statsOpen}
        close={() => setStatsOpen(false)}
        distanceUnit={settingsData.distanceUnit}
      />
      <div className="flex justify-center flex-auto dark:bg-slate-900 dark:text-slate-50">
        <div className="w-full max-w-lg flex flex-col">
                 <header className="border-b-2 px-3 border-gray-200 flex items-center gap-2 sm:gap-3">
            <div className="flex flex-col items-start leading-none">
              <button
                className="text-xl leading-none"
                type="button"
                onClick={() => setInfoOpen(true)}
              >
                ❓
              </button>
              <a
                className="text-xl leading-none no-underline whitespace-nowrap"
                href="https://kommundle.no/"
                target="_blank"
                rel="noopener noreferrer"
                title="Spill Kommundle"
                aria-label="Spill Kommundle"
              >
                ←<span className="hidden sm:inline">🌍</span>
              </a>
            </div>
            <h1 className="text-[clamp(1.125rem,5.8vw,2rem)] font-bold uppercase tracking-wide text-center my-1 flex-auto whitespace-nowrap">
              <span style={{color:"#EB4040"}}>V</span>
              <span style={{color:"#E11926"}}>A</span>
              <span style={{color:"#347103"}}>L</span>
              <span style={{color:"#00853D"}}>G</span>
              <span style={{color:"#87ADD7"}}>L</span>
              <span style={{color:"#004F80"}}>E</span>
            </h1>
          <div className="flex flex-col items-end leading-none">
              <div className="flex gap-2 sm:gap-3">
                <button
                  className="text-xl leading-none"
                  type="button"
                  onClick={() => setStatsOpen(true)}
                >
                  📈
                </button>
                <button
                  className="text-xl leading-none"
                  type="button"
                  onClick={() => setSettingsOpen(true)}
                >
                  ⚙️
                </button>
              </div>
              <a
                className="text-xl leading-none no-underline whitespace-nowrap"
                href="https://slagordle.kommundle.no/"
                target="_blank"
                rel="noopener noreferrer"
                title="Spill Slagordle"
                aria-label="Spill Slagordle"
              >
                <span className="hidden sm:inline">💬</span>→
              </a>
            </div>
          </header>
          <Game settingsData={settingsData} />
          <footer className="flex justify-center text-sm mt-8 mb-1">
            ❤️ <Worldle />? -
            <a
              className="underline pl-1"
              href="https://playgroundsforpalestine.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {"Gi lekeplasser til Palestina 🇵🇸"}
            </a>
          </footer>
        </div>
      </div>
    </>
  );
}

export default App;
